import styled from 'styled-components';

const MessageEventBtn = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  border-radius: 28px;
  border: 2px solid #e5e5e5;
  font-family: Gordita;
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  background: #e9e9e9;
  cursor: pointer;
  transition: all 0.15s ease;
  &:active {
    transform: scale(0.98);
    background: #fafafa;
  }
`;

export default MessageEventBtn;
